import { hostname } from "./host.js";

const env = "prod";
// const env = "bap";

const LOGIN_URL = hostname + "user/login";
const VALIDATE_TOKEN = hostname + "auth/validate_token";
const USER = hostname + "user";
const USER_PROFILE_LIST = hostname + "user/user-profile-list";
const GET_SEARCH_TEXT_LIST = hostname + "user/get-search-text-list";
const GET_MY_PROFILE = hostname + "user/get-my-profile";
const GET_USER_PROFILE = hostname + "user/get-user-profile";
const GET_CUSTOMER_DATA = hostname + "user/get-customer-data";
const UPDATE_CUSTOMER_DATA = hostname + "user/update-customer-data";

const GET_EMP_DOCS = hostname + "employee/documents";
const GET_EMP_LIST = hostname + "employee/list";

const USERS_LOAN = hostname + "user/loan_details";
const ALL_USERS_LOAN = hostname + "user/all_loan_details";
const TRANSACTION_LOGS = hostname + "user/get_transaction_details";
const TRANSACTION_LOG_FILE = hostname + "user/get_transaction_details";
const TRANSACTION_OFFER_LOG_FILE = hostname + "user/get_offer_details";
const AUDIT_TRAIL_REPORT = hostname + "report/audit-trail";
const USERS_ISSUES = hostname + "ticket/get_ticket_assigned";
const ISSUES = hostname + env + "/issue";
const CLOSE_ISSUES = hostname + env + "/issue-close";
const REPLY_ISSUES = hostname + "ticket/ticket-respond";
const ASSIGN_ISSUES = hostname + "ticket/ticket_assign_to_others";
const STATUS_ISSUES = hostname + env + "/get-issue-status";
const FORWORD_ISSUES = hostname + "ticket/ticket_forward_to_seller_gro";
const ALL_TICKETS = hostname + "ticket/get_all_ticket_admin";
const EMP_LIST = hostname + "ticket/get_all_ticket_emp";

const OFFER = hostname + env + "/all_offer";
const CREATE_OFFER = hostname + env + "/offer";
const CREATE_BLOG = hostname + env + "/blog";
const UPDATE_OFFER = hostname + env + "/update-offer";
const UPDATE_BLOG = hostname + env + "/update-blog";
const BLOGS = hostname + env + "/all_blogs";

const MSGS = hostname + "user/get-user-message";

const GET_NOTIFICATION = hostname + "notification/get-all-notification";
const SEND_NOTIFICATION = hostname + "notification/random-notification";

const LMS_RECORDS = hostname + "lms";

const CP = hostname + "channel-partner";
const UPDATE_CP = hostname + "channel-partner/update";

const LP = hostname + "lender-partner";
const UPDATE_LP = hostname + "lender-partner/update";

const TAB1 = hostname + "dashboard/tab1-single-value";
const TAB1MV = hostname + "dashboard/tab1-multiple-value";
const TAB6TICKETS = hostname + "dashboard/tab6-tickets";
const LOANDASHBOARDURI = hostname + "dashboard/loan-dashboard";

const ENQUIRY = hostname + "user/all-enquiry";

const ATTENDANCE_SUMMERY = hostname + "attendance/summery";
const ATTENDANCE_PUNCH_IN_OUT = hostname + "attendance/punch-in-out";
const ATTENDANCE_MONTH_WISE_SUMMERY = hostname + "attendance/month-wise-summery";


const EMP_LEAVE_REQUEST = hostname + "leave-request/employee";
const EMP_LEAVE_APPLY = hostname + "leave-request";
const EMP_LEAVE_BALANCE = hostname + "leave-request/available";


const PAY_SLIP_MONTH_WISE_SUMMERY = hostname + "pay-slip/month-wise-summery";
const PAY_SLIP_UPLOAD = hostname + "pay-slip/upload";




export const user = {
  LOGIN_URL,
  VALIDATE_TOKEN,
  USER,
  USER_PROFILE_LIST,
  GET_SEARCH_TEXT_LIST,
  GET_MY_PROFILE,
  GET_USER_PROFILE,
  GET_CUSTOMER_DATA,
  UPDATE_CUSTOMER_DATA,
  GET_EMP_DOCS
};

export const loan = {
  USERS_LOAN,
  ALL_USERS_LOAN,
  TRANSACTION_LOGS,
  TRANSACTION_LOG_FILE,
  TRANSACTION_OFFER_LOG_FILE,
  AUDIT_TRAIL_REPORT,
  ENQUIRY
};

export const tickets = {
  USERS_ISSUES,
  ISSUES,
  CLOSE_ISSUES,
  REPLY_ISSUES,
  ASSIGN_ISSUES,
  STATUS_ISSUES,
  FORWORD_ISSUES,
  ALL_TICKETS,
  EMP_LIST,
};

export const offerAndBlogs = {
  OFFER,
  BLOGS,
  CREATE_OFFER,
  CREATE_BLOG,
  UPDATE_OFFER,
  UPDATE_BLOG,
};

export const messages = {
  MSGS,
};

export const lms = {
  LMS_RECORDS,
};

export const notification = {
  GET_NOTIFICATION,
  SEND_NOTIFICATION,
};

export const cp = {
  CP,
  UPDATE_CP,
};

export const lp = {
  LP,
  UPDATE_LP,
};

export const dashboard = {
  TAB1,
  TAB1MV,
  TAB6TICKETS,
  LOANDASHBOARDURI,
};

export const attendance = {
  ATTENDANCE_SUMMERY,
  ATTENDANCE_PUNCH_IN_OUT,
  ATTENDANCE_MONTH_WISE_SUMMERY,
  GET_EMP_LIST
};

export const empLeaveApi = {
  EMP_LEAVE_REQUEST,
  EMP_LEAVE_APPLY,
  EMP_LEAVE_BALANCE
};

export const paySlipApi = {
  PAY_SLIP_MONTH_WISE_SUMMERY,
  PAY_SLIP_UPLOAD
};